import React from 'react';

import { styled } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const CommonTooltip = ({ children, ...rest }) => {
  return (
    <StyledTooltip
      placement='top'
      disableInteractive
      arrow
      {...rest}
      PopperProps={{
        style: {
          zIndex: 99999,
        },
      }}>
      {children}
    </StyledTooltip>
  );
};

const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    background: 'var(--table-row-bg-hover)',
    color: 'var(--text-stressed)',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    padding: '8px',
    maxWidth: 'unset',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--table-row-bg-hover)',
  },
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {
    bottom: '-8px',
  },
});

export default CommonTooltip;
